export const useError = data => {
  return data;
};



// WEBPACK FOOTER //
// ./src/api-map/error.js